/**
 * Enum with the http methods we use
 */
export var HTTP_METHOD;
(function (HTTP_METHOD) {
    HTTP_METHOD[HTTP_METHOD["GET"] = 0] = "GET";
    HTTP_METHOD[HTTP_METHOD["POST"] = 1] = "POST";
    HTTP_METHOD[HTTP_METHOD["PUT"] = 2] = "PUT";
    HTTP_METHOD[HTTP_METHOD["DELETE"] = 3] = "DELETE";
})(HTTP_METHOD || (HTTP_METHOD = {}));
/**
 * Enum with string representations of response types
 */
export var RESPONSE_TYPE;
(function (RESPONSE_TYPE) {
    RESPONSE_TYPE["JSON"] = "json";
    RESPONSE_TYPE["TEXT"] = "text";
    RESPONSE_TYPE["BLOB"] = "blob";
    RESPONSE_TYPE["XML"] = "xml";
    RESPONSE_TYPE["ARRAYBUFFER"] = "arraybuffer";
})(RESPONSE_TYPE || (RESPONSE_TYPE = {}));
export var OUTPUT_FORMAT;
(function (OUTPUT_FORMAT) {
    OUTPUT_FORMAT["JSON"] = "JSON";
    OUTPUT_FORMAT["RAPID_JSON"] = "rapidJSON";
})(OUTPUT_FORMAT || (OUTPUT_FORMAT = {}));
//# sourceMappingURL=http.enums.js.map